import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import { supabase } from "../supabase/client";

import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import Button from "../components/common/Button";
import TableData from "../components/common/TableData";
import {
  IconEdit,
  IconPdf,
  IconPlus,
  IconTrash,
} from "../components/icons/Icons";
import Modal from "../components/common/Modal";
import LettersForm from "../components/forms/LettersForm";
import { useDataBase } from "../context/DataBaseContext";

const CartasPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idData, setIdData] = useState(null);
//   const [cartas, setCartas] = useState([]);

  const { cartas, getCartas } = useDataBase();

  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    if (user !== null) {
      navigate("/cartas");
    }
    getCartas();
  }, [user]);

  const handleActiveChange = async (id, status) => {
    const { error } = await supabase
      .from("letters")
      .update({
        display: !status,
      })
      .eq("id", id);
    if (error) console.log("error", error);
    getCartas();
  };

  const columns = [
    {
      header: "Código",
      accessorKey: "code",
    },
    {
      header: "Expediente",
      accessorFn: (row) =>
        row.process !== null ? `${row.process.num_process}-${row.process.anio_process}-${row.process.class_process.name}` : "",
    },
    {
      header: "Remitente",
      accessorFn: (row) =>
        `${row.secretaries.users.first_name} ${row.secretaries.users.last_name}`,
    },
    {
      header: "Destinatario",
      accessorFn: (row) => `${row.persons.name}`,
    },
    {
      header: "Detalle",
      accessorKey: "detail",
    },
    {
      header: "F. elabo.",
      accessorFn: (row) => `${row.created_at.split("T")[0]}`,
    },
    {
      header: "F. envío",
      accessorFn: (row) => `${row.sending_date.split("T")[0]}`,
    },
    {
      header: "F. noti.",
      accessorFn: (row) => `${row.notification_date.split("T")[0]}`,
    },
    {
      header: "Secretario",
      accessorFn: (row) => `${row.users.first_name} ${row.users.last_name}`,
    },
    {
      header: "Visualiza",
      cell: ({ cell }) => {
        const display = cell.row.original.display;
        const id = cell.row.original.id;
        return (
          <button
            className={`flex items-center justify-center text-xs capitalize text-white rounded-full w-14 h-5 ${
              display === true ? "bg-success " : "bg-danger/40"
            }`}
            type="button"
            onClick={() => handleActiveChange(id, display)}
          >
            {display ? "Activo" : "Inactivo"}
          </button>
        );
      },
    },
    {
      header: "Acciones",
      cell: ({ cell }) => {
        const id = cell.row.original.id;
        const file = cell.row.original.file;
        return (
          <div className="flex items-center">
            <a
              href={"cv/" + file}
              target="_blank"
              rel="noreferrer"
              className={`${
                file !== null
                  ? `bg-primary/80 hover:bg-primary border-primary/80`
                  : `bg-secondary/30 border-secondary/10 pointer-events-none cursor-none`
              } border text-xs text-white px-2 py-1 rounded-sm`}
              title="Archivo"
              alt={file}
            >
              <IconPdf className="w-4" />
            </a>
            <button
              className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-2 py-1 rounded-sm"
              title="Editar"
              onClick={() => openModal(id)}
            >
              <IconEdit className="w-4" />
            </button>
            <button
              className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-2 py-1 rounded-sm"
              title="Eliminar"
              onClick={openModal}
            >
              <IconTrash className="w-4" />
            </button>
          </div>
        );
      },
    },
  ];

  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdData(id);
    // getModal()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <TitleBox title="Relación de cartas" />
      <ContainerBox>
        <Button value="Nuevo" openModal={() => openModal()}>
          <IconPlus className="w-4" />
        </Button>
        <TableData columns={columns} data={cartas} />
      </ContainerBox>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isModal={false}
        title={"Nuevo registro"}
      >
        <LettersForm idData={idData} onClose={closeModal} />
      </Modal>
    </>
  );
};

export default CartasPage;
